export const LOCALES ={
    ENGLISH: 'en-us'
  , POLISH:  'pl-pl'
  ,
}
